module.exports = __webpack_public_path__ + "static/media/50.f543f919.svg";